<div class="custom-image-tooltip" [hidden]="imageLoaded === false">
  <img (load)="loaded()" [src]="imageUrl" height="200px" />
</div>
